import React from 'react';
import PropTypes from 'prop-types';

const Flex = ({ 
  children, 
  alignItems = 'center',
  justifyContent = 'start',
  direction = 'row',
  wrap = 'nowrap',
  className = '',
  inline = false,
  ...rest 
}) => {
  const flexClasses = [
    inline ? 'd-inline-flex' : 'd-flex',
    `align-items-${alignItems}`,
    `justify-content-${justifyContent}`,
    `flex-${direction}`,
    `flex-${wrap}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={flexClasses} {...rest}>
      {children}
    </div>
  );
};

Flex.propTypes = {
  children: PropTypes.node,
  alignItems: PropTypes.oneOf(['start', 'end', 'center', 'baseline', 'stretch']),
  justifyContent: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around', 'evenly']),
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  className: PropTypes.string,
  inline: PropTypes.bool
};

export default Flex;
